import type { CSSProperties, RefObject } from 'react';
import type { JSONContent } from '@tiptap/core';

import { InteractionRichTextField } from './InteractionRichTextField';
import { clickExpandToolbarStyles } from './clickExpandEditorStyles';

interface ClickExpandRichFieldEditorProps {
  content: JSONContent;
  placeholder: string;
  isFocused: boolean;
  onFocus: () => void;
  onBlur: () => void;
  onContentChange: (content: JSONContent) => void;
  autoFocus: boolean;
  containerRef: RefObject<HTMLDivElement | null>;
  editorStyle?: CSSProperties;
}

export function ClickExpandRichFieldEditor({
  content,
  placeholder,
  isFocused,
  onFocus,
  onBlur,
  onContentChange,
  autoFocus,
  containerRef,
  editorStyle,
}: ClickExpandRichFieldEditorProps) {
  return (
    <InteractionRichTextField
      content={content}
      placeholder={placeholder}
      isFocused={isFocused}
      onFocus={onFocus}
      onBlur={onBlur}
      onContentChange={onContentChange}
      autoFocus={autoFocus}
      containerRef={containerRef}
      editorClassName="tiptap click-expand-editor"
      editorStyle={editorStyle}
      toolbarPreset="full"
      toolbarStyles={{
        toolbar: clickExpandToolbarStyles.toolbar,
        button: clickExpandToolbarStyles.toolbarButton,
        activeButton: clickExpandToolbarStyles.toolbarButtonActive,
      }}
    />
  );
}
